class VideoControl extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector("video");

    this.video.addEventListener("play", () => {
      this.setAttribute("state", "playing");
    });

    this.video.addEventListener("pause", () => {
      this.setAttribute("state", "paused");
    });

    this.video.addEventListener("volumechange", () => {
      this.setAttribute("mute-state", this.video.muted ? "muted" : "unmuted");
    });

    this.setAttribute("mute-state", this.video.muted ? "muted" : "unmuted");

    this.button = this.querySelector("[data-video-control-button]");

    const play = async () => {
      try {
        await this.video.play();
      } catch (err) {
        console.warn(err);
      }
    };

    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      this.video.paused ? play() : this.video.pause();
    });

    this.muteButton = this.querySelector("[data-video-mute-button]");

    if (this.muteButton) {
      this.muteButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.video.muted = !this.video.muted;
      });
    }
  }

  disconnectedCallback() {}
}

if (!customElements.get("video-control")) {
  customElements.define("video-control", VideoControl);
}
